import { forwardRef, PropsWithChildren } from 'react';
import styles from './qr-dialog.module.css';
import { useTranslation } from 'react-i18next';
import { Button } from '@lhb/ui';

type QRCodeDialogProps = PropsWithChildren<{
  onClose: () => void;
  closeBtnRef?: React.RefObject<HTMLButtonElement>;
}>;

export const QRCodeDialog = forwardRef<HTMLDialogElement, QRCodeDialogProps>(
  ({ children, onClose, closeBtnRef }, ref) => {
    const { t } = useTranslation('COMMON');

    return (
      <dialog ref={ref} className={styles.dialog}>
        <Button
          ref={closeBtnRef}
          onClick={onClose}
          className={styles.close}
          trailingIcon="cross"
        >
          {t('CLOSE')}
        </Button>

        {children}
      </dialog>
    );
  },
);
